<template>
    <div class="page order-list">
        <div class="order-head">
            <div class="tab" ref="tab">
                <span
                    :class="{ active: activeIndex == 0 }"
                    @click="tabClick(0)"
                >
                    全部
                </span>
                <span
                    :class="{ active: activeIndex == 1 }"
                    @click="tabClick(1)"
                >
                    待付款
                </span>
                <span
                    :class="{ active: activeIndex == 2 }"
                    @click="tabClick(2)"
                >
                    待审核
                </span>
                <span
                    :class="{ active: activeIndex == 3 }"
                    @click="tabClick(3)"
                >
                    待发货
                </span>
                <span
                    :class="{ active: activeIndex == 4 }"
                    @click="tabClick(4)"
                >
                    待收货
                </span>
                <span
                    :class="{ active: activeIndex == 5 }"
                    @click="tabClick(5)"
                >
                    已完成
                </span>
                <span
                    :class="{ active: activeIndex == 6 }"
                    @click="tabClick(6)"
                >
                    已关闭
                </span>
                <i>{{ tabX }}</i>
            </div>
            <!-- 搜索栏 -->
            <search-bar
                v-model="searchText"
                @search="reloadPageInfo"
                placeholder="搜索订单号/商品名称"
            />
        </div>
        <!-- 内容 -->
        <div class="content">
            <scroll
                v-if="orderList.length > 0"
                :data-list="orderList"
                :finished="finished"
                @load="getOrderList"
            >
                <div>
                    <order-list-item
                        v-for="(item, index) in orderList"
                        :data="item"
                        :key="index"
                    >
                    </order-list-item>
                </div>
            </scroll>
            <empty-data
                v-else
                iconText="暂无订单"
                :iconSrc="emptyIcon"
                :paddingTop="7"
                iconSize="slim"
            />
        </div>
        <foot-bar />
    </div>
</template>

<script>
import FootBar from "@/components/FootBar";
import SearchBar from "@/components/SearchBar";
import OrderListItem from "./children/OrderListItem";
import Scroll from "@/components/Scroll";
import EmptyData from "@/components/EmptyData";
import Vue from "vue";
import { List, Toast } from "vant";

Vue.use(List).use(Toast);

export default {
    name: "OrderList",
    components: { FootBar, SearchBar, OrderListItem, Scroll, EmptyData },
    data() {
        return {
            /* 路由参数 */
            query: {
                index: this.$route.query.index,
            },
            // 空数据icon
            emptyIcon: require("../../../public/images/user/order/order-null.png"),
            activeIndex: 0, // tab标签选中位置
            searchText: "", // 搜索内容
            /* 列表数据 */
            orderList: [],
            finished: false,
            /* 分页数据 */
            page: {
                currPage: 1,
                pageSize: this.$config.PAGE_ITEMS,
            },
            totalCount: 0,
        };
    },
    computed: {
        /* tab下标位置 */
        tabX() {
            this.$nextTick(() => {
                const $tab = this.$refs.tab;
                const spanWidth = $tab.firstChild.clientWidth;
                const iWidth = $tab.lastChild.clientWidth;
                const left =
                    spanWidth / 2 - iWidth / 2 + spanWidth * this.activeIndex;
                $tab.lastChild.style.transform = `translateX(${left}px)`;
            });
            return this.activeIndex;
        },
    },
    created() {
        // 有参数，则为tab标签下标赋值
        if (this.query.index) this.activeIndex = this.query.index;
        this.getOrderList();
    },
    methods: {
        /* 获取订单列表 */
        getOrderList() {
            // 获取订单状态码
            const orderStateArr = ["", 101, 102, 199, 449, 501, 601];
            const orderState = orderStateArr[this.activeIndex];
            // 获取数据
            const url = this.$api.userApi.order_queryOrderList;
            const params = {
                orderState,
                orderNo: this.searchText,
                page: this.page,
            };
            let _this = this;
            this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            this.$axios.post(url, params).then((res) => {
                const { data, totalCount } = res.data;
                this.orderList = this.orderList.concat(data);
                this.totalCount = totalCount;
                this.page.currPage++;
                _this.$toast.clear();
                // 数据全部加载完成
                if (this.orderList.length >= totalCount) {
                    this.finished = true;
                }
            });
        },
        /* tab点击事件 */
        tabClick(index) {
            this.activeIndex = index;
            this.reloadPageInfo();
            // 修改url地址参数
            this.$router.replace({
                path: "/user/order/list",
                query: {
                    index,
                },
            });
        },
        /* 重新获取页面数据 */
        reloadPageInfo() {
            // 重置 列表数据、当前页数、加载状态等，并获取数据
            this.orderList = [];
            this.page.currPage = 1;
            this.finished = false;
            this.getOrderList();
        },
    },
};
</script>

<style lang="less" scoped>
.order-list {
    .order-head {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        background: #fff;
        font-size: 28px;
        .tab {
            overflow-x: auto;
            overflow-y: hidden;
            height: 100px;
            white-space: nowrap;
            position: relative;

            span {
                display: inline-block;
                width: 20%;
                height: 100px;
                line-height: 100px;
                text-align: center;

                &.active {
                    color: @theme-color;
                    font-weight: bold;
                }
            }

            i {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 70px;
                height: 4px;
                background: @theme-color;
                transition-duration: 0.3s;
            }
        }
    }

    .content {
        top: 196px;
        bottom: 102px;
    }
}
</style>
